<ng-container #formDirective="parent-form" thr-parent-form>
    <thr-full-data-form-tax [tax]="client.tax" [isDisabled]="isDisabled" [isFormValid]="isFormValid"></thr-full-data-form-tax>
</ng-container>
